"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import Hero from "./components/hero";
import IntroComponent from "./components/intro";
import MigrationComponent from "./components/migration";
import MigrationTable from "./components/scenarios";
import WhyOnemindComponent from "./components/whyOnemind";
import PartnershipComponent from "./components/partnership";
import Faqs from "./components/faqs";

const ZadaraMigrationPage = () => {
  return (
    <>
      <PageLayout>
        <Hero />
        <IntroComponent />
      </PageLayout>
      <MigrationComponent />
      <PageLayout>
        <MigrationTable />
      </PageLayout>
      <Box>
        <WhyOnemindComponent />
        <PartnershipComponent />
      </Box>
      <PageLayout showContactForm>
        <Faqs />
      </PageLayout>
    </>
  );
};

export default ZadaraMigrationPage;
